"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnFrUsd = exports.EnFrEur = exports.FrFrUsd = exports.FrFrEur = void 0;
class FrFrEur {
    constructor() {
        this.locale = "fr-fr";
        this.dateFormat = {
            short: "dd/MM/yyyy",
            medium: "dd-MMM-yy",
            long: "dddd d MMMM yyyy",
        };
        this.currencyFormat = {
            code: "EUR",
            symbol: "€",
            decimalSeparator: ",",
            groupSeparator: " ",
            positivePattern: "n C",
            negativePattern: "-n C",
        };
    }
}
exports.FrFrEur = FrFrEur;
class FrFrUsd {
    constructor() {
        this.locale = "fr-fr";
        this.dateFormat = {
            short: "dd/MM/yyyy",
            medium: "dd-MMM-yy",
            long: "dddd d MMMM yyyy",
        };
        this.currencyFormat = {
            code: "USD",
            symbol: "$",
            decimalSeparator: ",",
            groupSeparator: " ",
            positivePattern: "n C",
            negativePattern: "-n C",
        };
    }
}
exports.FrFrUsd = FrFrUsd;
class EnFrEur {
    constructor() {
        this.locale = "en-fr";
        this.dateFormat = {
            short: "dd/MM/yyyy",
            medium: "dd-MMM-yy",
            long: "dddd d MMMM yyyy",
        };
        this.currencyFormat = {
            code: "EUR",
            symbol: "€",
            decimalSeparator: ",",
            groupSeparator: " ",
            positivePattern: "n C",
            negativePattern: "-n C",
        };
    }
}
exports.EnFrEur = EnFrEur;
class EnFrUsd {
    constructor() {
        this.locale = "en-fr";
        this.dateFormat = {
            short: "dd/MM/yyyy",
            medium: "dd-MMM-yy",
            long: "dddd d MMMM yyyy",
        };
        this.currencyFormat = {
            code: "USD",
            symbol: "$",
            decimalSeparator: ",",
            groupSeparator: " ",
            positivePattern: "n C",
            negativePattern: "-n C",
        };
    }
}
exports.EnFrUsd = EnFrUsd;
